export default {
  meta: {
    title: '新增采购单'
  }
};
